'use client';

import WelcomePage from 'components/Home/WelcomePage';
import Header from 'components/Layout/Common/Header';

const HomeClient = () => (
  <>
    <Header title='Home' />
    <WelcomePage />
  </>
);

export default HomeClient;
